<template>
    <div class="p-5">
        <PageTitle class="mt-2" title="Horário de Funcionamento" />

        <b-row v-for="(days, index) in fields" :key="index">
            <b-col>
                <OpenShop
                    :days="days.day"
                    :open="days.open"
                    :close="days.close"
                    :dataShop="dataShop"
                    class="mt-5"/>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import PageTitle from '../../../components/PageTitle.vue';
import { mapActions, mapState } from 'vuex';
import OpenShop from './OpenShop.vue';
import Weekday from '@/enums/Weekday.js';

export default {
    components: { PageTitle, OpenShop },

    data() {
        return {
            Weekday,
            fields: {
                mon: {
                    open: "",
                    close: "",
                    day: "Segunda-feira"
                },
                tue: {
                    open: "",
                    close: "",
                    day: "Terça-feira"
                },
                wed: {
                    open: "",
                    close: "",
                    day: "Quarta-feira"
                },
                thu: {
                    open: "",
                    close: "",
                    day: "Quinta-feira"
                },
                fri: {
                    open: "",
                    close: "",
                    day: "Sexta-feira"
                },
                sat: {
                    open: "",
                    close: "",
                    day: "Sábado"
                },
                sun: {
                    open: "",
                    close: "",
                    day: "Domingo"
                },
                hol: {
                    open: "",
                    close: "",
                    day: "Feriados"
                },
            },
            dataShop: [],
        }
    },

    computed: {
    ...mapState(['dadosUsuario']),
  },

  mounted() {
    this.listedHours();
  },

    methods: {
        ...mapActions('shopkeeper', ['getOpeningHours', 'saveOpeningHours']),

        listedHours() {
            this.$store.dispatch('startLoader');
            this.loading = true;

            this.getOpeningHours(this.dadosUsuario.id)
                .then((response) => {
                    this.dataShop = response;
                    
                    response.data.forEach(element => {
                        switch (element.day) {
                            case Weekday.MON:
                                this.fields.mon.day = element.day;
                                this.fields.mon.open = element.opening;
                                this.fields.mon.close = element.close;
                                break;
                            case Weekday.TUE:
                                this.fields.tue.day = element.day;
                                this.fields.tue.open = element.opening;
                                this.fields.tue.close = element.close;
                                break;
                            case Weekday.WED:
                                this.fields.wed.day = element.day;
                                this.fields.wed.open = element.opening;
                                this.fields.wed.close = element.close;
                                break;
                            case Weekday.THU:
                                this.fields.thu.day = element.day;
                                this.fields.thu.open = element.opening;
                                this.fields.thu.close = element.close;
                                break;
                            case Weekday.FRI:
                                this.fields.fri.day = element.day;
                                this.fields.fri.open = element.opening;
                                this.fields.fri.close = element.close;
                                break;
                            case Weekday.SAT:
                                this.fields.sat.day = element.day;
                                this.fields.sat.open = element.opening;
                                this.fields.sat.close = element.close;
                                break;
                            case Weekday.SUN:
                                this.fields.sun.day = element.day;
                                this.fields.sun.open = element.opening;
                                this.fields.sun.close = element.close;
                                break;
                            case Weekday.HOLI:
                                this.fields.hol.day = element.day;
                                this.fields.hol.open = element.opening;
                                this.fields.hol.close = element.close;
                        }
                    });
                })
                .finally(() => {
                this.$store.dispatch('endLoader');
                this.loading = false;
            });
        }
    }
}
</script>